import script from "./busanSubmission.vue?vue&type=script&setup=true&lang=js"
export * from "./busanSubmission.vue?vue&type=script&setup=true&lang=js"

import "./busanSubmission.vue?vue&type=style&index=0&id=ea0c4e18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea0c4e18"]])

export default __exports__